import * as React from "react";
import { useTranslation } from "@lib/useTypedTranslation";

import { ZeroSignalMap } from "../../../../components/maps/intensityMaps/zeroSignal";
import { Loading } from "../../../../components/loading/loading";
import { TimePeriodAndFilterPicker } from "../../../../components/timePeriodAndFilterPicker/timePeriodAndFilterPicker";
import { useFilterPicker } from "../../../../components/timePeriodAndFilterPicker/useFilterPicker";
import { useTimePeriodPicker } from "../../../../components/timePeriodAndFilterPicker/useTimePeriodPicker";
import { OptionPicker } from "@components/controls/optionPicker";
import { useSimProviderOptions } from "../useSimProviderOption";

export const PoorNoSignalTab = () => {
  const { t } = useTranslation('maps');

  const {
    filter,
    optionsLoading,
    ...filterPickerProps
  } = useFilterPicker();

  const {
    timePeriod,
    ...timePeriodPickerProps
  } = useTimePeriodPicker({ timePeriods: [30, 7, 2] });

  const { simProviderOptions, simProvider, setSimProvider, simProvidersLoading } = useSimProviderOptions();

  return <>
    <div className="core-maps_header">
      <div className="core-maps_headings">
        <h2>{t('VERY_POOR_NO_SERVICE_SUBHEADING')}</h2>
      </div>
      <div className="core-maps_filters">
        <TimePeriodAndFilterPicker
          filter={filter}
          {...filterPickerProps}
          timePeriod={timePeriod}
          {...timePeriodPickerProps}
          className='core-maps_time-and-estate-filters'
        />
        <div className="core-maps-options-filters">
          <OptionPicker
            options={simProviderOptions}
            onSelect={setSimProvider}
            current={simProvider}
            disabled={simProvidersLoading}
            selectText={t('SIM_PROVIDERS')}
            id="sim-provider-picker"
          />
        </div>
      </div>
    </div>
    <Loading isLoading={optionsLoading || simProvidersLoading} transparentOverlay={false}>
      <ZeroSignalMap
        groups={!filter.group ? undefined : [filter.group.value]}
        homeLocations={!filter.homeLocation ? undefined : [filter.homeLocation.value.id]}
        zoneId={filter.zone?.value.id}
        timePeriod={timePeriod.value}
        simProvider={simProvider?.value}
      />
    </Loading>
  </>;
};
